import CollectPayment from 'shared-assets/components/PaymentSolutions/CollectPayment';

angular
  .module('kareo.ui.shared.directives.collect-payment', [
    'react'
  ])
  .directive('collectPayment', dcCollectPayment);

dcCollectPayment.$inject = ['reactDirective'];

function dcCollectPayment(reactDirective) {
  const bindings = {
    name: '=',
    address1: '=',
    onConfirmTransaction: '=',
    onConfirmTransactionCOF: '=',
    onUpdateNote: '=',
    onFinalizePayment: '=',
    patientBalance: '=',
    zip: '=',
    patient: '=',
    practice: '=',
  };

  return reactDirective(CollectPayment, bindings, props => {
    return {
      ...props,
      zip: String(props.zip).slice(0, 5),
    };
  });
}
